/** ErgData-style heart rate line colors from workout-relative intensity. */
export const CONCEPT2_HR_ZONE_COLORS = {
  low: '#22c55e',
  moderate: '#eab308',
  high: '#ef4444',
} as const;

export function concept2HeartRateZoneColor(
  heartRate: number,
  minHeartRate: number,
  maxHeartRate: number
): string {
  if (!Number.isFinite(heartRate)) {
    return CONCEPT2_HR_ZONE_COLORS.low;
  }

  if (maxHeartRate <= minHeartRate) {
    return CONCEPT2_HR_ZONE_COLORS.moderate;
  }

  const ratio = (heartRate - minHeartRate) / (maxHeartRate - minHeartRate);

  if (ratio < 0.55) {
    return CONCEPT2_HR_ZONE_COLORS.low;
  }

  if (ratio < 0.8) {
    return CONCEPT2_HR_ZONE_COLORS.moderate;
  }

  return CONCEPT2_HR_ZONE_COLORS.high;
}
